import { useState } from "react";
import { Heart } from "lucide-react";
import api from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { cn } from "@/lib/utils";

export function FavoriteButton({ listingId, initial = false, onToggle, className }) {
  const { user } = useAuth();
  const navigate = useNavigate();
  const [fav, setFav] = useState(initial);
  const [loading, setLoading] = useState(false);

  const toggle = async (e) => {
    e.preventDefault();
    e.stopPropagation();
    if (!user) {
      toast.info("Favorilere eklemek için giriş yapın");
      navigate("/giris");
      return;
    }
    setLoading(true);
    try {
      const { data } = await api.post(`/favorites/${listingId}`);
      setFav(data.favorited);
      onToggle?.(data.favorited);
    } catch {
      toast.error("İşlem başarısız");
    } finally {
      setLoading(false);
    }
  };

  return (
    <button
      type="button"
      onClick={toggle}
      disabled={loading}
      data-testid={`favorite-btn-${listingId}`}
      aria-label="Favorilere ekle"
      className={cn(
        "flex h-9 w-9 items-center justify-center rounded-full bg-white/90 backdrop-blur border border-slate-200 shadow-sm transition-colors hover:bg-white",
        className
      )}
    >
      <Heart className={cn("h-4.5 w-4.5 transition-colors", fav ? "fill-red-500 text-red-500" : "text-slate-500")} size={18} />
    </button>
  );
}
